import { wei } from '@kwenta/wei';
import { erc20Abi, maxUint256 } from 'viem';
export default class TokensService {
    sdk;
    constructor(sdk) {
        this.sdk = sdk;
    }
    async approveTokenSpend({ address, spender, signer, amount = maxUint256, chainId, }) {
        return await this.sdk.context.publicClient(chainId).simulateContract({
            abi: erc20Abi,
            address,
            account: signer ?? this.sdk.context.walletAddress,
            functionName: 'approve',
            args: [spender, amount],
        });
    }
    async transferToken({ address, to, amount, signer, chainId, }) {
        const { request } = await this.sdk.context.publicClient(chainId).simulateContract({
            abi: erc20Abi,
            address,
            account: signer ?? this.sdk.context.walletAddress,
            functionName: 'transfer',
            args: [to, amount],
        });
        return request;
    }
    async getBalancesAndAllowances(tokens, owner, spenders, chainId) {
        const tokenItems = tokens
            .map((token) => ({
            token,
            contract: this.sdk.context.contractConfigs[chainId]?.tokens[token],
        }))
            .filter((c) => !!c.contract?.address);
        if (!tokenItems.length)
            throw new Error(`${tokens} not found on current network`);
        const balanceCalls = tokenItems.map((contract) => ({
            address: contract.contract?.address,
            abi: erc20Abi,
            functionName: 'balanceOf',
            args: [owner],
        }));
        const decimalsCalls = tokenItems.map((contract) => ({
            address: contract.contract?.address,
            abi: erc20Abi,
            functionName: 'decimals',
            args: [],
        }));
        const spenderCalls = tokenItems.flatMap((t) => [
            ...spenders.map((s) => ({
                address: t.contract?.address,
                abi: erc20Abi,
                functionName: 'allowance',
                args: [owner, s],
            })),
        ]);
        const results = await this.sdk.context.publicClient(chainId).multicall({
            allowFailure: false,
            contracts: [...balanceCalls, ...decimalsCalls, ...spenderCalls],
        });
        const balances = results.slice(0, balanceCalls.length);
        const decimals = results.slice(balanceCalls.length, balanceCalls.length + decimalsCalls.length);
        const allowances = results.slice(balanceCalls.length + decimalsCalls.length);
        return tokenItems.reduce((acc, t, i) => {
            const balance = balances[i];
            const decimal = Number(decimals[i]);
            acc[t.token] = {
                balance: wei(balance ?? 0, Number(decimal)).toString(),
                allowances: spenders.reduce((acc, s, si) => {
                    const index = i * spenders.length + si;
                    acc[s] = wei(allowances[index], Number(decimal)).toString();
                    return acc;
                }, {}),
            };
            return acc;
        }, {});
    }
    async getEthBalance(address, chainId) {
        const res = await this.sdk.context.publicClient(chainId).getBalance({ address });
        return res.toString();
    }
}
//# sourceMappingURL=tokens.js.map